import { StorageService } from 'core-tsi'
import { VERSION_KEY } from '../../pwa-update.service'

export const getActiveSession = (): any => {
  try {
    const session = StorageService.getSession()
    return session && session.token ? session : null
  } catch {
    return null
  }
}

export const hasActiveSession = (): boolean => getActiveSession() != null

export const clearSessionStorage = () => {
  const unDeleted = new Set([VERSION_KEY])
  const keys = Object.keys(localStorage)
  let count = keys.length

  while (count--) {
    const key = keys[count]
    unDeleted.has(key) ? null : localStorage.removeItem(key)
  }
}
